import React from 'react';
import { Text } from 'react-native';
import { JsonFormsRendererRegistryEntry, LabelProps, rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsLabelProps } from '@jsonforms/react';
import { RENDERER_RANK_DEFAULT_FALLBACK } from '../constants';

export const LabelRenderer: JsonFormsRendererRegistryEntry = {
  tester: rankWith(RENDERER_RANK_DEFAULT_FALLBACK, uiTypeIs('Label')),
  renderer: withJsonFormsLabelProps((props: LabelProps) => {
    return <Text>{props.text}</Text>;
  }),
};
